export default __webpack_public_path__ + "static/media/Chiptronical.f3f52265.ogg";